import { useMeterAndConsumption } from '@features/bx/singleBillGenaration/hooks';
import { GenericTable } from '@shared/components/GenericTable';
import { useDebounce } from '@shared/hooks/useDebounce';
import { TableColumn } from '@shared/types/table';
import { PAGE_SIZE } from '@shared/utils/constants';
import React, { useState } from 'react'

function MeterConsumption({consumerNo}) {
  const [searchData, setSearchData] = useState("");
  const search = useDebounce(searchData, 300);
  const {data: meterConsumption} = useMeterAndConsumption(consumerNo, search);
    const columns: TableColumn[] = [
    {
      key: "utilityService",
      header: "Utility Service",
    },
    { key: "meterNumber", header: "Meter No", type: "text" },
    {
      key: "previousReading",
      header: "Prev Reading",
      type: "text",
    },
    {
      key: "previousReadingDate",
      header: "Prev Date",
      type: "text",
    },
    {
      key: "currentReading",
      header: "Curr Reading",
      type: "text",
    },
    {
      key: "currentReadingDate",
      header: "Curr Date",
    },
    {
      key: "consumption",
      header: "Consumption",
    },
    {
      key: "serviceDays",
      header: "Service Days",
    },
  ];

  const handlePageChange = (p: number) => {};
  const handleSearch = (search: string) => {};

  return (
      <GenericTable
        data={meterConsumption?.result ?? []}
        columns={columns}
        rowKey="id"
        // pagination={{
        //   currentPage,
        //   totalPages,
        //   totalItems,
        //   itemsPerPage: pageSize,
        //   startItem: (currentPage - 1) * pageSize + 1,
        //   endItem: Math.min(currentPage * pageSize, totalItems),
        // }}
        pagination={{
          currentPage: 1,
        //   totalPages,
        totalPages: 10,
        //   totalItems,
        totalItems: 10,
          itemsPerPage: PAGE_SIZE,
          startItem: (1 - 1) * PAGE_SIZE + 1,
          endItem: Math.min(1 * PAGE_SIZE, 10),
        }}
        onPageChange={handlePageChange}
        onSearch={handleSearch}
        searchPlaceholder="Search by Invoice number..."
        emptyMessage="No Data Found."
        loading={false}
      />
    );
}

export default MeterConsumption